/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListMessagesQueryResponse, IncidentInvestigationControllerListMessagesPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerListMessages";

function getIncidentInvestigationControllerListMessagesUrl(id: IncidentInvestigationControllerListMessagesPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/messages` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/messages}
 */
export async function incidentInvestigationControllerListMessages(id: IncidentInvestigationControllerListMessagesPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerListMessagesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerListMessagesUrl(id).url.toString(), ... requestConfig })  
  return res.data
}